/**
 * Common string constants
 */
export enum STRINGS {
  FILE_SIZE_DESCRIPTION = '< 1.0MB',
  ACCOUNTABLE_ENTITY_LEGAL_NAME = '<Accountable entity legal name>',
  ACCOUNTABLE_ENTITY = 'Accountable entity',
  ALL_FIELDS_REQUIRED_MESSAGE = 'All fields are required unless marked optional.',
  JSON_MIME = 'application/json',
  CATEGORY = 'Category',
  CSV_EXTENSION = 'csv',
  DATA_SUBMITTED_REFRESH_PAGE_TEXT = 'DATA_SUBMITTED_REFRESH_PAGE_TEXT',
  DATA_FEEDS = 'Data feeds',
  EDIT = 'Edit',
  ERROR_DOWNLOADING_SCHEMA = 'Error downloading schema=',
  ERROR_DOWNLOADING_TEMPLATE = 'Error downloading template=',
  FEED_ID = 'Feed ID',
  FILTER_PAGE_KEY = 'feeds',
  FEEDS = 'Feeds',
  FILE_UPLOADED_REFRESH_PAGE_TEXT = 'FILE_UPLOADED_REFRESH_PAGE_TEXT',
  SUBMIT_DATA_BY_FILE_UPLOAD = 'File upload',
  FIND_OUT_HOW_TO = 'Find out how to',
  FOR_PAST_ACTIVITY_IN_THIS_FEED = 'For past activity in this feed, see',
  SYSTEMS_SUPPORT = 'For systems support and enquiries',
  HISTORY = 'History',
  INVALID_SCHEMA_JSON = 'Invalid schema JSON=',
  JSON_EXTENSION = 'json',
  JSON_LABEL = 'JSON',
  LATEST_DATA = 'Latest data',
  NAME = 'Name',
  FEED_NO_DATA = 'No data yet',
  NO_FEED_TO_DISPLAY = 'No feeds to display.',
  SUBMIT_DATA_BY_ONLINE_FORM = 'Online form',
  CONTACT_EMAIL = 'regulations@bom.gov.au',
  RESOURCES = 'Resources',
  SCHEMA = 'Schema',
  SETUP_API_AND_SFTP = 'Set up API and SFTP',
  STATUS = 'Status',
  SUBMIT_DATA = 'Submit data',
  SUPPORT = 'Support',
  TEMPLATE = 'Template',
  CSV_MIME = 'text/csv',
  WM_DECISIONS = 'wm-decisions',
  WM1_ETWRS_ON_ISSUE = 'wm1-etwrs_on_issue'
}

// Message functions for STRINGS keys. Use these when the message needs something inserted as a placeholder (slot).

export const STRING_COMPONENTS: Partial<
  Record<STRINGS, (slot: React.ReactNode, slot2?: React.ReactNode) => React.ReactNode>
> = {
  [STRINGS.FILE_UPLOADED_REFRESH_PAGE_TEXT]: (slot, slot2) => (
    <>
      File uploaded.
      {slot2 && (
        <>
          {' '}
          Data ID is <span className="strong">{slot2}</span>.
        </>
      )}{' '}
      This data is now processing, which may take some time. Refresh the page to view the results in {slot}.
    </>
  ),
  [STRINGS.DATA_SUBMITTED_REFRESH_PAGE_TEXT]: (slot, slot2) => (
    <>
      Form submitted.
      {slot2 && (
        <>
          {' '}
          Data ID is <span className="strong">{slot2}</span>.
        </>
      )}{' '}
      This data is now processing, which may take some time. Refresh the page to view the results in {slot}.
    </>
  )
};
